<template>
  <footer class="pt1 pb3 align--center-on-mobile">
    <div class="container">
      <div class="grid-row">
        <div class="grid-column mt2 span-half">
          <div class="mb1">
            <span>
              <a :href="iosLink" class="link"><img class="download" src="../../static/ios.png" alt="Download on the App Store"></a>
            </span>
            <span>
              <a :href="androidLink" class="link"><img class="download" src="../../static/googleplay.png" alt="Download on Google Play"></a>
            </span>
          </div>
          <p class="small p1">Made with <span style="color: #e25555;">&#9829;</span> in Chicago</p>
          <p class="small p1"><a href="https://www.chefy.io" class="link link--text">Chefy, LLC</a>&nbsp; &#9400; {{ year }}</p>
        </div>
        <div class="grid-column mt2 span-half align--right align--center-on-mobile">
          <ul class="no-bullets list--inline">
            <li class="mr2"><a href="../../static/privacy.txt" class="link">Privacy</a></li>
            <li class="mr1"><a href="../../static/terms.txt" class="link">Terms</a></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'foot',
  data() {
    return {
      year: (new Date()).getFullYear()
    }
  },

  computed: {
    androidLink() {
      return this.$store.state.androidLink
    },

    iosLink() {
      return this.$store.state.iosLink
    }
  }
}
</script>

<style lang="scss" scoped>
   @import '../assets/scss/main.scss'
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue